<template>
  <div>
    <div style="padding-bottom: 15px;">
      <template>
        <div class="row rowgap" v-if="isHRManager">
          <div class="col-md-12">
            <p class="title-content">
              <b class="note-content">Note: Updates will be shared with the student.</b>
            </p>
            <p class="title-content" v-if="isupdate !== true">
              <b class="note-content">A new Form I-983 will be created with this material change. So, please verify and sign the new form.</b>
            </p>
          </div>
        </div>
        <div class="row rowgap">
          <div class="col-md-12">
            <div class="form-group">
              <label>Select Material Change</label><span class="validation-star">*</span>
              <ob-select2 :inModal="true" :options="materialChangeOptions" :change="onMaterialChange" :multiple="true" v-model="MaterialChange" :class="{ 'ob-vuelidate_input-error': $v.MaterialChange.$error }"></ob-select2>
              <span class="ob-vuelidate_error-msg" v-if="$v.MaterialChange.$dirty && !$v.MaterialChange.required">Select material change</span>
            </div>
          </div>
        </div>
        <div class="row rowgap" v-if="MaterialChange != '' && MaterialChange != null">
          <div class="col-md-12">
            <b> Provide the information as per the Form I-983's material change</b>
          </div>
        </div>

        <template v-if="showSpecifyReason">
          <div class="row rowgap">
            <div class="col-md-12">
              <div class="form-group">
                <label>Specify reason for others</label><span class="validation-star">*</span>
                <ob-textarea :maxLength="150" v-model.trim="SpecifyReason" placeholder="Enter Specify Reason" :class="{ 'ob-vuelidate_input-error': $v.SpecifyReason.$error }"></ob-textarea>
                <span class="ob-vuelidate_error-msg" v-if="$v.SpecifyReason.$dirty && !$v.SpecifyReason.requiredIf"> Enter Specify Reason</span>
              </div>
            </div>
          </div>
        </template>

        <template v-if="showChangeOfEID || showPeriodicEvaluationFromTheUniversity">
          <div class="row rowgap">
            <div class="col-md-4">
              <div class="form-group">
                <label>Employer ID Number (EIN)</label><span class="validation-star">*</span>
                <ob-input v-model.trim="EmployerInfo.EmployerIDNumber" placeholder="Enter Employer ID Number" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.EmployerIDNumber.$error }"></ob-input>
                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.EmployerIDNumber.$dirty && !$v.EmployerInfo.EmployerIDNumber.requiredIf">Enter Employer ID Number</span>
              </div>
            </div>
          </div>
        </template>

        <template v-if="showReductionInComp || showPeriodicEvaluationFromTheUniversity">
          <div class="row rowgap">
            <div class="col-md-4">
              <div class="form-group">
                <label>OPT Hours Per Week</label><span class="validation-star">*</span>
                <ob-input :maxLength="15" v-model.trim="EmployerInfo.OPTHoursPerWeek" placeholder="e.g. 25 or 20 - 40" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.OPTHoursPerWeek.$error }"></ob-input>
                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && !$v.EmployerInfo.OPTHoursPerWeek.requiredIf"> Enter OPT Hours Per Week</span>
                 <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && $v.EmployerInfo.OPTHoursPerWeek.requiredIf && !$v.EmployerInfo.OPTHoursPerWeek.ValidOPTHoursPerWeek">Enter 20-40 hours/week, or a range with hyphen only (e.g. 20 - 40).</span>
              </div>
            </div>
          </div>
          <div class="row rowgap">
            <div class="col-md-4">
              <div class="form-group">
                <label>Salary Amount</label><span class="validation-star">*</span>
                <ob-input icon="fa-usd"  v-decimal-numbers v-model.trim="EmployerInfo.Salary" placeholder="Salary Amount" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.Salary.$error }"></ob-input>
                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.Salary.$dirty && !$v.EmployerInfo.Salary.requiredIf"> Enter Salary Amount</span>
			        	 <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.Salary.$dirty && $v.EmployerInfo.Salary.requiredIf && !$v.EmployerInfo.Salary.ValidSalary"> Enter valid Salary Amount</span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Salary Frequency</label><span class="validation-star">*</span>
                <ob-select2 :inModal="true" v-model.trim="EmployerInfo.SalaryType" :options="salary" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.SalaryType.$error }"></ob-select2>
                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.SalaryType.$dirty && !$v.EmployerInfo.SalaryType.ValidSalaryType"> Select Salary Frequency</span>
              </div>
            </div>
          </div>
        </template>

        <template v-if="showdecreaseinHoursPerWeek && showReductionInComp == false && showPeriodicEvaluationFromTheUniversity == false">
          <div class="row rowgap">
            <div class="col-md-4">
              <div class="form-group">
                <label>OPT Hours Per Week</label><span class="validation-star">*</span>
                <i class="fa fa-info-circle" v-tooltip="'Enter a number from 20 to 40, or a range using hyphen only (e.g. 20 - 40, 25 - 35).'" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.OPTHoursPerWeek.$error }"></i>
                <ob-input :maxLength="15" v-model.trim="EmployerInfo.OPTHoursPerWeek" placeholder="e.g. 25 or 20 - 40" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.OPTHoursPerWeek.$error }"></ob-input>
                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && !$v.EmployerInfo.OPTHoursPerWeek.requiredIf"> Enter OPT Hours Per Week</span>
                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && $v.EmployerInfo.OPTHoursPerWeek.requiredIf && !$v.EmployerInfo.OPTHoursPerWeek.ValidOPTHoursPerWeek">Enter 20-40 hours/week, or a range with hyphen only (e.g. 20 - 40).</span>
              </div>
            </div>
          </div>
        </template>
        <template v-if="showChangeInEmployerSite || showSpecifyReason">
            <div class="row rowgap">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Site Name</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="StudentDetails.SignatoryAuthority.SiteName" placeholder="Enter Site Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.SiteName.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteName.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteName.requiredIf">Enter Site Name</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteName.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteName.maxLength && $v.StudentDetails.SignatoryAuthority.SiteName.alpha">Enter 150 characters only</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteName.$dirty &&  $v.StudentDetails.SignatoryAuthority.SiteName.alpha && !$v.StudentDetails.SignatoryAuthority.SiteName.letterCount">Each word can have a maximum of 100 characters only.</span>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="form-group">
                        <label>Site Address (Street, City, State, ZIP)</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="StudentDetails.SignatoryAuthority.SiteAddress" placeholder="Enter Site Address (Street, City, State, ZIP)" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.SiteAddress.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteAddress.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteAddress.requiredIf">Enter Site Address</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteAddress.$dirty && !$v.StudentDetails.SignatoryAuthority.SiteAddress.maxLength && $v.StudentDetails.SignatoryAuthority.SiteAddress.alpha">Enter 150 characters only</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.SiteAddress.$dirty &&  $v.StudentDetails.SignatoryAuthority.SiteAddress.alpha && !$v.StudentDetails.SignatoryAuthority.SiteAddress.letterCount">Each word can have a maximum of 100 characters only.</span>
                    </div>
                </div>
            </div>
             <div class="row rowgap">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Name of Official</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="StudentDetails.SignatoryAuthority.NameOfOficial" placeholder="Enter Name of Official" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.NameOfOficial.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.requiredIf">Enter Name of Official</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.alphawithspace">Enter alphabets only</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.maxLength && $v.StudentDetails.SignatoryAuthority.NameOfOficial.alpha">Enter 150 characters only</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.NameOfOficial.$dirty &&  $v.StudentDetails.SignatoryAuthority.NameOfOficial.alpha && !$v.StudentDetails.SignatoryAuthority.NameOfOficial.letterCount">Each word can have a maximum of 100 characters only.</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Official's Title</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="StudentDetails.SignatoryAuthority.Title" placeholder="Enter Official's Title" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.Title.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Title.$dirty && !$v.StudentDetails.SignatoryAuthority.Title.requiredIf">Enter Official's Title</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Title.$dirty && !$v.StudentDetails.SignatoryAuthority.Title.maxLength && $v.StudentDetails.SignatoryAuthority.Title.alpha">Enter 150 characters only</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Title.$dirty &&  $v.StudentDetails.SignatoryAuthority.Title.alpha && !$v.StudentDetails.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span>
                    </div>
                </div>
                <div class="col-md-4 ">
                    <div class="form-group">
                        <label>Official's Email</label><span class="validation-star">*</span>
                        <ob-input v-model.trim="StudentDetails.SignatoryAuthority.Email" placeholder="Enter Official's Email" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.Email.$error }"></ob-input>
                        <template v-if="$v.StudentDetails.SignatoryAuthority.Email.$dirty">
                            <span class="ob-vuelidate_error-msg" v-if="!$v.StudentDetails.SignatoryAuthority.Email.requiredIf">Enter Official's Email</span>
                            <span class="ob-vuelidate_error-msg" v-else-if="!$v.StudentDetails.SignatoryAuthority.Email.email">Enter valid email</span>
                        </template>
                    </div>
                </div>
            </div>
             <div class="row rowgap">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Official's Phone Number</label><span class="validation-star">*</span>
                        <ob-input v-phone-number v-model.trim="StudentDetails.SignatoryAuthority.Phone" placeholder="Enter Official's Phone Number" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SignatoryAuthority.Phone.$error }"></ob-input>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Phone.$dirty && !$v.StudentDetails.SignatoryAuthority.Phone.requiredIf">Enter Phone Number</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Phone.$dirty && !$v.StudentDetails.SignatoryAuthority.Phone.phoneNumber && $v.StudentDetails.SignatoryAuthority.Phone.requiredIf">Enter valid Phone Number</span>
                        <!-- <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Phone.$dirty && !$v.StudentDetails.SignatoryAuthority.Phone.maxLength && $v.StudentDetails.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span>
                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SignatoryAuthority.Phone.$dirty && !$v.StudentDetails.SignatoryAuthority.Phone.minLength && $v.StudentDetails.SignatoryAuthority.Phone.phoneNumber">Enter valid Phone Number</span> -->
                    </div>
                </div>
            </div>
        </template>
        <template v-if="showChangetoTheEmployeeComm || showPeriodicEvaluationFromTheUniversity">
          <div class="row rowgap">
            <div class="col-md-12">
              <div class="form-group">
                <label>Training Plan Title</label><span class="validation-star">*</span>
                <ob-input v-model.trim="StudentDetails.TrainingPlan.Title" placeholder="Enter Training Plan Title" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.TrainingPlan.Title.$error }"></ob-input>
                <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.TrainingPlan.Title.$dirty && !$v.StudentDetails.TrainingPlan.Title.requiredIf"> Enter Training Plan Title</span>
              </div>
            </div>
          </div>
          <div class="row rowgap">
            <div class="col-md-12">
              <div class="form-group">
                <label>Student Role: Describe the student's role with the employer and how that role is directly related to enhancing the student's knowledge obtained through his or her qualifying STEM degree.</label>
                <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.StudentRole" placeholder="Enter student roles"></ob-textarea>
              </div>
            </div>
          </div>
          <div class="row rowgap">
            <div class="col-md-12">
              <div class="form-group">
                <label>Goals and Objectives: Describe how the assignment(s) with the employer will help the student achieve his or her specific objectives for workbased learning related to his or her STEM degree. The description must both specify the student's
                  goals regarding specific knowledge, skills, or techniques as well as the means by which they will be achieved.</label>
                <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.GoalsAndObjectives" placeholder="Enter Goals and Objectives"></ob-textarea>
              </div>
            </div>
          </div>
          <div class="row rowgap">
            <div class="col-md-12">
              <div class="form-group">
                <label>Employer Oversight: Explain how the employer provides oversight and supervision of individuals filling positions such as that being filled by the named F-1 student. If the employer has a training program or related policy in place that
                  controls such oversight and supervision, please describe.
                </label>
                <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.EmployerOversight" placeholder="Enter Employer Oversight"></ob-textarea>
              </div>
            </div>
          </div>
          <div class="row rowgap">
            <div class="col-md-12">
              <div class="form-group">
                <label>Measures and Assessments: Explain how the employer measures and confirms whether individuals filling positions such as that being filled by the named F-1 student are acquiring new knowledge and skills. If the employer has a training program
                  or related policy in place that controls such measures and assessments, please describe.</label>
                <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.MeasuresAndAssessments" placeholder="Enter Measures and Assessments"></ob-textarea>
              </div>
            </div>
          </div>
          <div class="row rowgap">
            <div class="col-md-12">
              <div class="form-group">
                <label>Additional Remarks (optional): Provide additional information pertinent to the Plan.</label>
                <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.Remarks" placeholder="Enter Additional Remarks"></ob-textarea>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
    <div class="row rowgap"  style="border-top: 1.5px dashed #d4cccc;margin-top: 15px; padding-top: 15px;">
        <b class="col-md-12" style="padding-bottom:15px">Choose your preferred option to initiate material change<span class="validation-star">*</span></b>
        <div class="col-md-6">
            <ob-radio name="I983FormType"  :val="true" v-model="IsInitiateOnlySectionType"><b>Initiate Material Change Only</b></ob-radio>
            <p style="padding-left: 20px;">Creates only material change section (Employer information - section 3 & 4)</p>
        </div>
        <div class="col-md-6">
            <ob-radio name="I983FormType"  :val="false" v-model="IsInitiateOnlySectionType"><b>Initiate New Form I-983</b></ob-radio>
            <p style="padding-left: 20px;">Creates a new Form I-983 by auto-populating all the data from the existing one1.</p>
        </div>
    </div>
    <div class="modal-footer">
      <ob-button type="secondary" @click="show = false">Cancel</ob-button>
      <ob-button type="primary" @click="onMaterialChangeInitiated">{{ isupdate ? 'Update' : 'Initiate' }}</ob-button>
    </div>
  </div>
</template>
<script>
  import {
    required, minLength, maxLength, requiredIf, email, alpha, minValue
  }
  from 'vuelidate/lib/validators'
  import {
    req, withParams
  }
  from 'vuelidate/lib/validators/common'
  const DecimalNumber = withParams({
    type: 'DecimalNumber'
  }, value => {
    return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
  })
  const alphawithspace = (value) => {
    var alsp = /^[a-zA-Z\s]*$/i
    return alsp.test(value)
  }
  const phoneNumber = (param) =>
    withParams(
        { type: 'phoneNumber', value: param},
        (value) => { 
            if(param && (param.indexOf("ChangeInEmployerSite") > -1)  || param.indexOf("Others") > -1) {
               if(value.length > 9 && value.length < 21)
               {
                var phone = /^[0-9 +()-]+$/i
                return phone.test(value)
               }
               else
               {
                 return false
               }
            } else {
                return true;
            }
        }
    );
  const letterCount = withParams({
    type: 'letterCount'
  }, value => {
    if (value != null && value.length <= 150) {
      var strArr = value.split(" ");
      let error = true;
      strArr.forEach(function(word) {
        if (word.length > 100) {
          error = false
          return;
        }
      });
      return !req(value) || error
    } else {
      return true
    }

  })

  const ValidSalaryType = (param) =>
    withParams(
        { type: 'ValidSalaryType', value: param},
        (value) => {
            if(param && (param.indexOf("ReductionInStudentCompensation") > -1 || param.indexOf("PeriodicEvaluationFromTheUniversity") > -1)  || param.indexOf("Others") > -1) {
                return value != "None" && value != "";
            } else {
                return true;
            }
        }
    );

    const ValidSalary = (param) =>
        withParams(
            { type: 'ValidSalary', value: param},
            (value) => {
                if(param && (param.indexOf("ReductionInStudentCompensation") > -1 || param.indexOf("PeriodicEvaluationFromTheUniversity") > -1)  || param.indexOf("Others") > -1) {
                    return value > 0;
                } else {
                    return true;
                }
            }
        );

    const ValidOPTHoursPerWeek = (param) =>
        withParams(
            { type: 'ValidOPTHoursPerWeek', value: param},
            (value) => {
                if(!(param && ((param.indexOf("ReductionInStudentCompensation") > -1) || param.indexOf("DecreaseInHoursPerweek") > -1) || param.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || param.indexOf("Others") > -1)){
                    return true;
                }
                if (!req(value)) {
                    return true;
                }
                const normalized = String(value).trim();
                if (normalized === '') {
                    return true;
                }
                if (/^\d+$/.test(normalized)) {
                    const n = parseInt(normalized, 10);
                    return n >= 20 && n <= 40;
                }
                if (/^\d+\s*-\s*\d+$/.test(normalized)) {
                    const parts = normalized.split('-');
                    const low = parseInt(parts[0].trim(), 10);
                    const high = parseInt(parts[1].trim(), 10);
                    if (Number.isNaN(low) || Number.isNaN(high)) {
                        return false;
                    }
                    if (low < 20 || low > 40 || high < 20 || high > 40) {
                        return false;
                    }
                    return low <= high;
                }
                return false;
            }
        );


  export default {
    props: ["openModal", "isupdate", "updatecontent"],
    data() {
      return {
        IsInitiateOnlySectionType:'',
        show: '',
        MaterialChange: '',
        showSpecifyReason:false,
        SpecifyReason:'',
        EmployerInfo: {
          EmployerIDNumber: '',
          Salary: '',
          SalaryType: '',
          OPTHoursPerWeek: ''
        },
        StudentDetails: {
          TrainingPlan: {
            Title: '',
            StudentRole: '',
            GoalsAndObjectives: '',
            EmployerOversight: '',
            MeasuresAndAssessments: '',
            Remarks: ''
          },
          StudentName: '',
          Email: '',
          SignatoryAuthority: {
            SiteName: '',
            SiteAddress: '',
            NameOfOficial: '',
            Title: '',
            Email: '',
            Phone: ''
          },
        },
        materialChangeOptions: {
          data: [
            {
              id: "ChangeOfEmployerIdentificationNumber",
              text: 'Change of the employer’s Employer Identification Number (i.e., the company’s Federal Tax ID number)'
            }, {
              id: "ReductionInStudentCompensation",
              text: 'Reduction in student compensation that is not tied to a reduction in hours worked'
            }, {
              id: "DecreaseInHoursPerweek",
              text: 'Significant decrease in hours per week that a student engages in a STEM training opportunity'
            }, {
              id: "ChangesCommitmentsOrObjectives",
              text: 'Changes to the employer’s commitments or student’s learning objectives as documented on the Form I-983'
            },
            { id: "PeriodicEvaluationFromTheUniversity",
              text: 'Periodic evaluation from  the University'
            },
            {
              id:"ChangeInEmployerSite",
              text:"Change in employer site"
            },
            { id: "Others" , text: 'Others'}
          ],
          placeholder: {
            id: '-1',
            text: 'Please select'
          },
        },
        showChangeOfEID: '',
        showReductionInComp: '',
        showdecreaseinHoursPerWeek: '',
        showChangetoTheEmployeeComm: '',
        showPeriodicEvaluationFromTheUniversity:'',
        showChangeInEmployerSite:false,
        salary: {
          data: [{
            "id": "Hourly",
            "text": "Hourly"
          }, {
            "id": "Weekly",
            "text": "Weekly"
          }, {
            "id": "BiWeekly",
            "text": "Bi-Weekly"
          }, {
            "id": "Monthly",
            "text": "Monthly"
          }, {
            "id": "SemiMonthly",
            "text": "Semi-Monthly"
          }, {
            "id": "Yearly",
            "text": "Yearly"
          }, ],
          placeholder: "Select Salary Frequency"
        },
      }
    },
    watch: {
      openModal(val) {
          this.show = val;
          if (val === true) { // Open Modal
            this.copyFromStore();
          }
        },
        show(val) {
          this.$emit('update:openModal', val)
        },
    },
    computed: {
      EmployeeId() {
          return this.$parent.$parent.EmployeeId;
        },
        StudentName() {
            return this.$parent.$parent.StudentName;
        },
        onMaterialChange() {
          this.showChangeOfEID = false
          this.showReductionInComp = false
          this.showdecreaseinHoursPerWeek = false
          this.showChangetoTheEmployeeComm = false
          this.showPeriodicEvaluationFromTheUniversity = false
          this.showSpecifyReason = false
          this.showChangeInEmployerSite = false;

          if (this.MaterialChange) {
            for (var i = 0; i < this.MaterialChange.length; i++) {
              if (this.MaterialChange[i] == 'ChangeOfEmployerIdentificationNumber') {
                this.showChangeOfEID = true
              }
              if (this.MaterialChange[i] == 'ReductionInStudentCompensation') {
                this.showReductionInComp = true
              }
              if (this.MaterialChange[i] == 'DecreaseInHoursPerweek') {
                this.showdecreaseinHoursPerWeek = true
              }
              if (this.MaterialChange[i] == 'ChangesCommitmentsOrObjectives') {
                this.showChangetoTheEmployeeComm = true
              }
              if(this.MaterialChange[i] == 'PeriodicEvaluationFromTheUniversity')
              {
                this.showPeriodicEvaluationFromTheUniversity = true
              }
              if(this.MaterialChange[i] == 'Others')
              {
                this.showPeriodicEvaluationFromTheUniversity = true
                this.showSpecifyReason = true
              }
              if(this.MaterialChange[i] == 'ChangeInEmployerSite')
              {
                this.showChangeInEmployerSite = true;
              }
            }
          }

        }
    },
    created() {
      this.show = this.openModal;
      this.copyFromStore();
    },
    validations() {
      return {

        MaterialChange: {
          required
        },

        "EmployerInfo": {
          "EmployerIDNumber": {
            requiredIf: requiredIf(() => {
              if (this.MaterialChange.indexOf("ChangeOfEmployerIdentificationNumber") > -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1) {
                return true
              } else {
                return false
              }

            })
          },
          "Salary": {
            requiredIf: requiredIf(() => {
              if (this.MaterialChange.indexOf("ReductionInStudentCompensation") > -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1) {
                return true
              } else {
                return false
              }

            }),
              ValidSalary: ValidSalary(this.MaterialChange)
          },
          "SalaryType": {
            ValidSalaryType: ValidSalaryType(this.MaterialChange)
          },
          "OPTHoursPerWeek": {
            requiredIf: requiredIf(() => {

             if (this.MaterialChange.indexOf("ReductionInStudentCompensation") > -1 || this.MaterialChange.indexOf("DecreaseInHoursPerweek")> -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1){
                return true
              } else {
                return false
              }

            }),
              ValidOPTHoursPerWeek: ValidOPTHoursPerWeek(this.MaterialChange)
          }
        },
        StudentDetails: {
          "TrainingPlan": {
            "Title": {
              requiredIf: requiredIf(() => {
                if (this.MaterialChange.indexOf("ChangesCommitmentsOrObjectives") > -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1){
                  return true
                } else {
                  return false
                }

              })
            }
          },
       "SignatoryAuthority": {
            "SiteName": {
               requiredIf: requiredIf(() => {
                if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                  return true
                } else {
                  return false
                }
              }),
              maxLength: maxLength(150),
                letterCount
            },
            "SiteAddress": {
               requiredIf: requiredIf(() => {
                if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                  return true
                } else {
                  return false
                }
              }),
              maxLength: maxLength(150),
                letterCount
            },
            "NameOfOficial": {
              requiredIf: requiredIf(() => {
                if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                  return true
                } else {
                  return false
                }
              }),
              alphawithspace,
              maxLength: maxLength(150),
                letterCount
            },
            "Title": {
              requiredIf: requiredIf(() => {
                if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                  return true
                } else {
                  return false
                }
              }),
              alphawithspace,
              maxLength: maxLength(150),
                letterCount
            },
            "Email": {
              requiredIf: requiredIf(() => {
                if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                  return true
                } else {
                  return false
                }
              }),
              email
            },
            "Phone": {
              requiredIf: requiredIf(() => {
                if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                  return true
                } else {
                  return false
                }
              }),
              phoneNumber : phoneNumber(this.MaterialChange),
              // maxLength: maxLength(20),
              // minLength: minLength(10)
            }
          },
        },
        SpecifyReason:{
          requiredIf: requiredIf(() => {
            if (this.MaterialChange.indexOf("Others") > -1){
              return true
            } else {
              return false
            }

            })
        }
      }
    },
    methods: {
        getSupervisorDetails()
        {
            ajax.get(`/I983/GetSupervisorDetails?EmployeeId=${this.EmployeeId}&ConsultantId=${this.loggedInUserObj.consultantId}`, {}, (res) => {
                if(res.data.State == true && res.data.EmployeeDetail != null && res.data.EmployeeDetail.EmailId != null) {
                  var address1 = res.data.EmployeeDetail.Address.Address1 != null && res.data.EmployeeDetail.Address.Address1 != '' ? res.data.EmployeeDetail.Address.Address1 + "," : '';
                  var street = res.data.EmployeeDetail.Address.StreetNo != null && res.data.EmployeeDetail.Address.StreetNo != '' ? res.data.EmployeeDetail.Address.StreetNo + "," : '';
                  var city = res.data.EmployeeDetail.Address.City != null && res.data.EmployeeDetail.Address.City != '' ? res.data.EmployeeDetail.Address.City + "," : '';
                  var state = res.data.EmployeeDetail.Address.State != null && res.data.EmployeeDetail.Address.State != '' ? res.data.EmployeeDetail.Address.State + "," : '';
                  var zip = res.data.EmployeeDetail.Address.ZipCode != null && res.data.EmployeeDetail.Address.ZipCode != '' ? res.data.EmployeeDetail.Address.ZipCode : '';
                  var address = address1 + street + city + state + zip
                  var name = res.data.EmployeeDetail.FirstName+" "+res.data.EmployeeDetail.LastName
                  var designation = res.data.EmployeeDetail.Designation;

                  var signatoryAuthority = {
                      SiteName: res.data.EmployeeDetail.ClientOrganizationName != '' && res.data.EmployeeDetail.ClientOrganizationName != null ? res.data.EmployeeDetail.ClientOrganizationName : res.data.EmployeeDetail.OrganizationName,
                      SiteAddress: address ,
                      NameOfOficial: this.updatecontent.Employer.Supervisor.Name,
                      Title: this.updatecontent.Employer.Supervisor.Title,
                      Email: this.updatecontent.Employer.Supervisor.Email,
                      Phone: this.updatecontent.Employer.Supervisor.MobileNo,
                    }
                    this.StudentDetails.SignatoryAuthority = signatoryAuthority
                }
                else{
                  var signatoryAuthority = {
                      SiteName: this.loggedInUserObj.OrgName,
                      SiteAddress: this.loggedInUserObj.OrgAddress ,
                      NameOfOficial: this.loggedInUserObj.Name,
                      Title: this.loggedInUserObj.Role,
                      Email: this.loggedInUserObj.Email,
                      Phone: '',
                    }
                    this.StudentDetails.SignatoryAuthority = signatoryAuthority
                }
            })
        },
      copyFromStore() {
          if (this.isupdate == true) { // When update copy the values from the store
            this.MaterialChange = this.updatecontent.MaterialChange.MaterialChangeType;
            this.SpecifyReason = this.updatecontent.MaterialChange.SpecifyReason;

            this.EmployerInfo.EmployerIDNumber = this.updatecontent.MaterialChange.EIN;
            this.EmployerInfo.OPTHoursPerWeek = this.updatecontent.MaterialChange.OPTHours;
            this.EmployerInfo.Salary = this.updatecontent.MaterialChange.Salary;
            this.EmployerInfo.SalaryType = this.updatecontent.MaterialChange.SalaryFrequency;

            this.StudentDetails.TrainingPlan.Title = this.updatecontent.MaterialChange.Training.Title;
            this.StudentDetails.TrainingPlan.StudentRole = this.updatecontent.MaterialChange.Training.StudentRole;
            this.StudentDetails.TrainingPlan.GoalsAndObjectives = this.updatecontent.MaterialChange.Training.Objectives;
            this.StudentDetails.TrainingPlan.EmployerOversight = this.updatecontent.MaterialChange.Training.EmployerOverSight;
            this.StudentDetails.TrainingPlan.MeasuresAndAssessments = this.updatecontent.MaterialChange.Training.Assessments;
            this.StudentDetails.TrainingPlan.Remarks = this.updatecontent.MaterialChange.Training.AdditionalRemarks;

            this.IsInitiateOnlySectionType = false;

             let interval = setInterval(() => {
                    clearInterval(interval);
                    this.IsInitiateOnlySectionType = false;
             }, 10);

            this.getSupervisorDetails()

          }
        },
        copyToStore() {
          let obj = {
            MaterialChange: {
              Training: {}
            }
          };

          obj.MaterialChange.MaterialChangeType = this.MaterialChange;
          obj.MaterialChange.SpecifyReason = this.SpecifyReason;
          obj.MaterialChange.ModifiedLogs = this.updatecontent.MaterialChange.ModifiedLogs;

          obj.MaterialChange.EIN = this.EmployerInfo.EmployerIDNumber;
          obj.MaterialChange.OPTHours = this.EmployerInfo.OPTHoursPerWeek;
          obj.MaterialChange.Salary = this.EmployerInfo.Salary;
          obj.MaterialChange.SalaryFrequency = this.EmployerInfo.SalaryType;

          obj.MaterialChange.Training.Title = this.StudentDetails.TrainingPlan.Title;
          obj.MaterialChange.Training.StudentRole = this.StudentDetails.TrainingPlan.StudentRole;
          obj.MaterialChange.Training.Objectives = this.StudentDetails.TrainingPlan.GoalsAndObjectives;
          obj.MaterialChange.Training.EmployerOverSight = this.StudentDetails.TrainingPlan.EmployerOversight;
          obj.MaterialChange.Training.Assessments = this.StudentDetails.TrainingPlan.MeasuresAndAssessments;
          obj.MaterialChange.Training.AdditionalRemarks = this.StudentDetails.TrainingPlan.Remarks;

          this.$emit('update:updatecontent', obj);

        },
        onMaterialChangeInitiated() {
          this.$v.StudentDetails.$touch();
          this.$v.EmployerInfo.$touch();
          this.$v.MaterialChange.$touch();
           this.$v.SpecifyReason.$touch();
          if (this.$v.StudentDetails.$invalid == false && this.$v.EmployerInfo.$invalid == false && this.$v.MaterialChange.$invalid == false  && this.$v.SpecifyReason.$invalid == false) {
            this.show = false

             var Signatoryauthority = {
              SiteName: this.StudentDetails.SignatoryAuthority.SiteName,
              SiteAddress: this.StudentDetails.SignatoryAuthority.SiteAddress,
              Name: this.StudentDetails.SignatoryAuthority.NameOfOficial,
              Title: this.StudentDetails.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.StudentDetails.SignatoryAuthority.Title,
              Email: this.StudentDetails.SignatoryAuthority.Email,
              Phone: this.StudentDetails.SignatoryAuthority.Phone,
            };


            var employee = {
              EmployeeId: !this.$parent.$parent.isSupervisor ? this.EmployeeId : this.$parent.$parent.EmployeeId ,
              Name: this.StudentName
            }
            var employer = {
              EIN: this.EmployerInfo.EmployerIDNumber,
              OPTHours: this.EmployerInfo.OPTHoursPerWeek,
              Salary: this.EmployerInfo.Salary,
              SalaryFrequency: this.EmployerInfo.SalaryType,
              SignatoryAuthority: Signatoryauthority
            }
            var trainingPlan = {
              Title: this.StudentDetails.TrainingPlan.Title == 'HRManager' ? 'HR Manager': this.StudentDetails.TrainingPlan.Title,
              StudentRole: this.StudentDetails.TrainingPlan.StudentRole,
              Objectives: this.StudentDetails.TrainingPlan.GoalsAndObjectives,
              EmployerOverSight: this.StudentDetails.TrainingPlan.EmployerOversight,
              Assessments: this.StudentDetails.TrainingPlan.MeasuresAndAssessments,
              AdditionalRemarks: this.StudentDetails.TrainingPlan.Remarks
            }
            var assignedTraining = {
              Training: trainingPlan
            }
            var materialChange = {
              MaterialChangeType: this.MaterialChange,
              SpecifyReason: this.SpecifyReason
            }
            let obj = {
              Employee: employee,
              Employer: employer,
              MaterialChange: materialChange,
              AssignedTraining: assignedTraining,
              Type: "MaterialChange"
            }

            if (this.isupdate == true) {
              this.makeUpdateAPICall(obj);
            } else {
              this.makeInitiateAPICall(obj);
            }
          }
        },
        makeInitiateAPICall(obj) {
          this.$loading({
            'loadingText': 'Initiating Material Change...'
          });
          ajax.post(`/I983/Initiate?empOrgId=${loggedInUserObj.orgId}`, obj, (res) => {
            if (res.data.State == true) {
              this.$message({
                type: 'success',
                message: 'Material Change initiated successfully'
              });
              this.$loading({}).close()
              this.show = false
              this.$emit('initiated');
            } else if (res.data.State == false) {
              this.$loading({}).close()
              this.show = false
              this.ESSEnableDisable(res)
              this.$message({
                type: 'error',
                message: res.data.Message
              });
            }
          });
        },
        makeUpdateAPICall(obj) {
          this.$loading({
            'loadingText': 'Updating Material Change...'
          });
          ajax.put(`/I983/${this.updatecontent.Id}/UpdateMaterialChange`, obj, (res) => {
            if (res.data.State == true) {
              this.$message({
                type: 'success',
                message: 'Material Change updated successfully'
              });
              this.$loading({}).close()
              this.show = false;
              this.copyToStore();
              this.$parent.$parent.insertModifiedLogToStore('MaterialChange');
            } else if (res.data.State == false) {
              this.$loading({}).close()
              this.show = false
              this.ESSEnableDisable(res)
              this.$message({
                type: 'error',
                message: res.data.Message
              });
            }
          });
        }
    }
  }
</script>
<style lang="scss" scoped>
  .title-content {
    color: #4a90e2;
    font-size: 14px;
  }
  .note-content
  {
    color: #4a90e2;
    font-weight: 600;
    font-size: 13px;
  }
  .rowgap {
    margin-top: 10px;
  }

  .validation-star {
    color: #F31D1D;
  }

  .radio-inline {
    padding-left: 0px
  }

  label {
    color: #a4abb9
  }

  .preview-details {
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateFlow/InitiateMaterialChangePopup.vue